module.exports = __webpack_public_path__ + "img/07.47fa2cfb.jpg";